import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './LoadForm.module.scss';

import MissionPreview from '@/components/ui/MissionPreview';
import MissionTable from '@/components/ui/MissionTable';
import { getCommandForSurveySegment } from '@/helpers/CommandConverter';
import { ModalService as modal } from '@/libs/Modal';
import { NotifierService as notifier } from '@/libs/Notifier';
import { deepCopy } from '@/utils/ObjectUtils';

const cx = classNames.bind(styles);

const LoadForm = () => {
  const navigate = useNavigate();
  const [selectedMission, setSelectedMission] = useState();

  const handleSelect = (mission) => {
    const nextSelectedMission = deepCopy(mission);
    nextSelectedMission.json.commands = mission.json.commands.map((command) => getCommandForSurveySegment(command));
    setSelectedMission(nextSelectedMission);
  };

  const doOK = () => {
    if (!selectedMission) {
      notifier.error('No item selected.');
      return;
    }

    navigate(`/mission-hub/${selectedMission.id}`, { replace: true });
    modal.hide();
  };

  return (
    <div className={cx('container')}>
      <div className={cx('wrapper')}>
        <MissionTable onSelect={handleSelect} />
        <MissionPreview mission={selectedMission} />
      </div>
      <button type="button" className={cx(['button', 'accent'])} onClick={doOK}>
        OK
      </button>
    </div>
  );
};

export default LoadForm;
